var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade show",
          attrs: {
            id: "cancel-single-apparatus-multiple-subscriptions",
            role: "dialog"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered modal-lg",
              staticStyle: { width: "560px" }
            },
            [
              _c("span", { attrs: { tabindex: "0" } }),
              _c(
                "div",
                { staticClass: "modal-content", attrs: { tabindex: "-1" } },
                [
                  _c("header", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row w-100 no-gutters align-items-center"
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c("h2", { staticClass: "modal-title" }, [
                            _c("i", {
                              staticClass:
                                "far fa-circle-dollar colorOrange mr-1"
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("xCancelPlanLowercase")) + " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "float-right col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-icon-button--gray btn-icon-button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.closeGenWithMultipleSubscriptionsModal()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("xCancelPlanForMultipleSubs", {
                                0: _vm.currentPremiumSubscription
                                  ?.subscriptionProductName,
                                1: _vm.currentPremiumSubscription
                                  ?.subscriptionCost,
                                2: _vm
                                  .$moment(
                                    _vm.currentPremiumSubscription
                                      ?.subscriptionRenewalDate
                                  )
                                  .format(_vm.$t("xShortDate")),
                                3: _vm.getApparatusTypeAsString,
                                4: _vm.apparatus?.preferredDealerName
                              })
                            ) +
                            " "
                        )
                      ])
                    ])
                  ]),
                  _c("ModalFooter", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary flex flex-grow-1",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.cancelPlan()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("xCancelPlanLowercase")) + " "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade show",
          attrs: {
            id: "remove-home-premium-apparatus-multiple-subscriptions",
            role: "dialog"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered modal-lg",
              staticStyle: { width: "560px" }
            },
            [
              _c("span", { attrs: { tabindex: "0" } }),
              _c(
                "div",
                { staticClass: "modal-content", attrs: { tabindex: "-1" } },
                [
                  _c("header", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row w-100 no-gutters align-items-center"
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c("h2", { staticClass: "modal-title" }, [
                            _c("i", {
                              staticClass:
                                "fa-regular fa-circle-info colorOrange mr-1"
                            }),
                            _vm._v(" " + _vm._s(_vm.$t("xRemoveProduct")) + " ")
                          ])
                        ]),
                        _c("div", { staticClass: "float-right col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-icon-button--gray btn-icon-button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.closeApparatusHomePremiumWithMultipleSubscriptionsModal()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("xRemovingApparatusForMultipleSubs", {
                                0: _vm.apparatus?.name
                              })
                            ) +
                            " "
                        )
                      ])
                    ])
                  ]),
                  _c("ModalFooter", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary flex flex-grow-1",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeApparatusHomePremiumWithMultipleSubscriptionsModal()
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("xNoKeepThisProduct")) + " ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary flex flex-grow-1",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.removePlan()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("xYesRemoveThisProduct")) + " "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade show",
          attrs: {
            id: "apparatus-with-multiple-subscriptions-mobile-platform",
            role: "dialog"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered modal-lg",
              staticStyle: { width: "560px" }
            },
            [
              _c("span", { attrs: { tabindex: "0" } }),
              _c(
                "div",
                { staticClass: "modal-content", attrs: { tabindex: "-1" } },
                [
                  _c("header", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row w-100 no-gutters align-items-center"
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c("h2", { staticClass: "modal-title" }, [
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-circle colorOrange mr-1"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xYourAccountNeedsAttentionHeader")
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "float-right col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-icon-button--gray btn-icon-button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.closeApparatusWithMultipleSubscriptionsMobilePlatformModal()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "mb-3" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "xApparatusHasMultipleSubsOnMobileBodyText1",
                                  {
                                    0: _vm.apparatus?.name,
                                    1: _vm.apparatus?.preferredDealerName,
                                    2: _vm.currentPremiumSubscription
                                      ?.subscriptionProductName,
                                    3: _vm
                                      .$moment(
                                        _vm.currentPremiumSubscription
                                          ?.subscriptionRenewalDate
                                      )
                                      .format(_vm.$t("xShortDate"))
                                  }
                                )
                              ) +
                              " "
                          )
                        ]),
                        _vm.currentPremiumSubscription?.subscriptionStore ===
                        _vm.subscriptionStoreTypesApple
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "xApparatusHasMultipleSubsOnAppleBodyText2"
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      "https://account.apple.com/account/manage/section/subscriptions."
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm.currentPremiumSubscription?.subscriptionStore ===
                        _vm.subscriptionStoreTypesGoogle
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "xApparatusHasMultipleSubsOnAndroidBodyText2"
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      "https://play.google.com/store/account/subscriptions."
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _c("ModalFooter", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary flex flex-grow-1",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeApparatusWithMultipleSubscriptionsMobilePlatformModal()
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
                    )
                  ])
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade show",
          attrs: {
            id: "remove-apparatus-with-multiple-subscriptions-mobile-platform",
            role: "dialog"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered modal-lg",
              staticStyle: { width: "560px" }
            },
            [
              _c("span", { attrs: { tabindex: "0" } }),
              _c(
                "div",
                { staticClass: "modal-content", attrs: { tabindex: "-1" } },
                [
                  _c("header", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row w-100 no-gutters align-items-center"
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c("h2", { staticClass: "modal-title" }, [
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-circle colorOrange mr-1"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xYourAccountNeedsAttentionHeader")
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "float-right col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-icon-button--gray btn-icon-button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "mb-3" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "xRemoveApparatusHasMultipleSubsOnMobileBodyText1",
                                  {
                                    0: _vm.apparatus?.name,
                                    1: _vm.apparatus?.preferredDealerName,
                                    2: _vm.getApparatusTypeAsString,
                                    3: _vm.currentPremiumSubscription
                                      ?.subscriptionProductName
                                  }
                                )
                              ) +
                              " "
                          )
                        ]),
                        _vm.currentPremiumSubscription?.subscriptionStore ===
                        _vm.subscriptionStoreTypesApple
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "xRemoveApparatusHasMultipleSubsOnAppleBodyText2"
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      "https://account.apple.com/account/manage/section/subscriptions."
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm.currentPremiumSubscription?.subscriptionStore ===
                        _vm.subscriptionStoreTypesGoogle
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "xRemoveApparatusHasMultipleSubsOnAndroidBodyText2"
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      "https://play.google.com/store/account/subscriptions."
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _c("ModalFooter", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary flex flex-grow-1",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
                    )
                  ])
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: {
            modalId: "cancel-multiple-subscriptions-spinner-modal",
            size: "modal-lg"
          }
        },
        [
          _c(
            "ModalBody",
            {
              staticStyle: { "padding-top": "100px", "padding-bottom": "100px" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center"
                },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "10rem", height: "10rem" },
                    attrs: { variant: "warning" }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }